import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Grid } from 'components/UI'
import AdminUserList from './AdminUserList'
import ManagerUserList from './ManagerUserList'
import ProfileCard from './ProfileCard'

function UserList ({ role }) {
  switch (role) {
    case 'Admin':
      return <AdminUserList />
    case 'Manager':
      return <ManagerUserList />
    default:
      return <div />
  }
}

class Profile extends Component {

  render () {
    const {
      userDetails,
      role,
    } = this.props

    const {
      givenName,
      familyName,
    } = userDetails

    return (
      <Grid>
        <Grid.Row>
          <h1>
            {`${givenName} ${familyName}`}
          </h1>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col>
            <ProfileCard info={userDetails} />
          </Grid.Col>
          <Grid.Col desktopOnly />
        </Grid.Row>
        <Grid.Row>
          <UserList role={role} />
        </Grid.Row>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  userDetails: state.auth.userDetails,
  role: state.auth.role,
})

export default connect(mapStateToProps)(Profile)



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.jsx